import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Maximize = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 25 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M14.75 4.343h5a1 1 0 0 1 1 1v5m-16 4v5a1 1 0 0 0 1 1h5m9.5-15.5-5.5 5.5m-4 4-5.5 5.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14 4.343a.75.75 0 0 1 .75-.75h5c.966 0 1.75.784 1.75 1.75v5a.75.75 0 0 1-1.5 0v-4.19l-4.72 4.72a.75.75 0 1 1-1.06-1.06l4.719-4.72h-4.19a.75.75 0 0 1-.75-.75m-10 10a.75.75 0 1 1 1.5 0v4.19l4.72-4.72a.75.75 0 1 1 1.06 1.06l-4.72 4.72h4.19a.75.75 0 1 1 0 1.5h-5A1.75 1.75 0 0 1 4 19.343z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
